import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrackingService } from '../../services/app-track/tracking.service';
import { AuthService } from '../../services/security/auth.service';

@Injectable()
export class TrackingInterceptor implements HttpInterceptor {
  constructor(
    private trackingService: TrackingService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // 🚫 si viene marcado para no trackear, lo dejamos pasar directo
    if (req.headers.has('x-skip-tracking')) {
      return next.handle(req);
    }

    const url = req.url.toLowerCase();
    const body = req.body || {};

    // ⚡ devolvemos un Observable que espera a obtener los datos del usuario
    return new Observable<HttpEvent<any>>((observer) => {
      this.authService.getAuthInfo().then((logInfo) => {
        const userCC = logInfo?.document || '';
        const cedulaAsesor = userCC.includes('.')
          ? userCC.split('.')[1].trim()
          : userCC;
        const nombreAsesor = logInfo
          ? `${logInfo.nombre ?? ''} ${logInfo.primerApellido ?? ''} ${
              logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';

        // 1️⃣ Carné de usuarios
        if (url.includes('card')) {

          // 2️⃣ Cotizador
        } else if (url.includes('cotizador')) {

          let funcionalidad: string | null = null;
          let identificadorInteraccion: string | null = null;

          if (url.includes('/save')) {
            funcionalidad = 'Generar cotización';
            identificadorInteraccion = 'COTIZADOR_GENERAR_COTIZACION';
          } else if (url.includes('/send')) {
            funcionalidad = 'Enviar cotización';
            identificadorInteraccion = 'COTIZADOR_ENVIAR';
          }

          // 👉 solo enviar tracking si aplica
          if (funcionalidad && identificadorInteraccion) {
            const trackData: any = {
              module: 'Cotizador',
              category: 'N/A',
              submodule: url.includes('/mis')
                ? 'Mis Cotizaciones'
                : 'Cotizador',
              functionality: funcionalidad,
              cedulaAsesor,
              fechaInteraccion: this.getCurrentTimestamp(),
              nombreAsesor: logInfo?.nombre || 'N/A',
              identificadorInteraccion,
            };

            this.trackingService.trackEvent(trackData).subscribe({
              next: () =>
                console.log('TrackingInterceptor - Evento registrado'),
              error: () =>
                console.warn('TrackingInterceptor - Error registrando evento'),
            });
          }
        }

        // ✅ continuar con el request original
        next.handle(req).subscribe({
          next: (event) => observer.next(event),
          error: (err) => observer.error(err),
          complete: () => observer.complete(),
        });
      });
    });
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}
